import Reveal from '@/components/base/Reveal';

const loopNodes = [
  { label: 'MARKET', left: 50, top: 8 },
  { label: 'INGEST', left: 82.8, top: 23.8 },
  { label: 'FILTER', left: 90.9, top: 59.3 },
  { label: 'DECIDE', left: 68.2, top: 87.8 },
  { label: 'EXECUTE', left: 31.8, top: 87.8 },
  { label: 'MANAGE', left: 9.1, top: 59.3 },
  { label: 'RECORD', left: 17.2, top: 23.8 },
];

function SystemLoop() {
  return (
    <section
      id="loop"
      className="w-full bg-background-100 border-y border-background-200 px-4 md:px-8 lg:px-12 py-16 md:py-24"
    >
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <h2 className="text-center font-heading font-extrabold tracking-tight text-foreground-950 text-[32px] leading-[1.08] sm:text-[42px] lg:text-[48px]">
            The EA Works As A Continuous Loop
          </h2>
        </Reveal>

        {/* ring — desktop */}
        <Reveal delay={120}>
          <div className="hidden md:block relative mx-auto mt-16 w-full max-w-[560px] aspect-square">
            <div className="absolute inset-[10%] rounded-full border border-dashed border-primary-400/70 animate-[spin_70s_linear_infinite]"></div>
            <div className="absolute inset-[26%] rounded-full border border-primary-200"></div>

            {/* reject branch — filter loops back to ingest */}
            <div
              className="absolute inset-[20%] rounded-full pointer-events-none"
              style={{
                background:
                  'conic-gradient(from 0deg, transparent 0deg 51deg, oklch(var(--primary-500)) 51deg 103deg, transparent 103deg 360deg)',
                WebkitMaskImage:
                  'radial-gradient(closest-side, transparent calc(100% - 2px), #000 calc(100% - 2px))',
                maskImage:
                  'radial-gradient(closest-side, transparent calc(100% - 2px), #000 calc(100% - 2px))',
              }}
            ></div>
            <i
              className="ri-arrow-left-up-line absolute -translate-x-1/2 -translate-y-1/2 text-[15px] text-primary-600"
              style={{ left: '73%', top: '31%' }}
            ></i>
            <span
              className="absolute -translate-x-1/2 -translate-y-1/2 inline-flex items-center gap-1.5 rounded-full border border-dashed border-primary-300 bg-background-100 px-2 py-0.5"
              style={{ left: '80%', top: '43%' }}
            >
              <i className="ri-loop-left-line text-[11px] text-primary-600"></i>
              <span className="text-[10px] font-data tracking-wider text-primary-700 whitespace-nowrap">
                REJECT
              </span>
            </span>

            <div className="absolute inset-[38%] rounded-full border border-primary-400 bg-background-50 flex flex-col items-center justify-center">
              <span className="text-[10px] font-data tracking-[0.2em] text-foreground-500">
                SYSTEM LOOP
              </span>
              <span className="mt-1 font-heading font-extrabold text-foreground-950 text-[22px]">
                XAUUSD
              </span>
            </div>

            {loopNodes.map((node) => (
              <div
                key={node.label}
                className="absolute -translate-x-1/2 -translate-y-1/2 rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5"
                style={{ left: `${node.left}%`, top: `${node.top}%` }}
              >
                <span className="text-[11px] font-data tracking-wider text-foreground-800 whitespace-nowrap">
                  {node.label}
                </span>
              </div>
            ))}
          </div>
        </Reveal>

        {/* vertical — mobile */}
        <Reveal delay={120}>
          <div className="md:hidden mt-12 flex flex-col items-center">
            {loopNodes.map((node, idx) => (
              <div key={node.label} className="flex flex-col items-center">
                <div className="rounded-full border border-background-300 bg-background-50 px-4 py-2">
                  <span className="text-[12px] font-data tracking-wider text-foreground-800">
                    {node.label}
                  </span>
                </div>
                {node.label === 'FILTER' && (
                  <span className="my-2 inline-flex items-center gap-1.5 rounded-full border border-dashed border-primary-300 bg-primary-50 px-2.5 py-1">
                    <i className="ri-loop-left-line text-[12px] text-primary-600"></i>
                    <span className="text-[10px] font-data tracking-wider text-primary-700 whitespace-nowrap">
                      REJECT → BACK TO INGEST
                    </span>
                  </span>
                )}
                {idx < loopNodes.length - 1 && <span className="w-px h-5 bg-primary-400"></span>}
              </div>
            ))}
            <span className="w-px h-5 bg-primary-400"></span>
            <div className="rounded-full border border-primary-400 bg-primary-50 px-4 py-2">
              <span className="text-[12px] font-data tracking-wider text-primary-700">
                BACK TO MARKET
              </span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={200}>
          <div className="mt-12 flex flex-col items-center gap-2.5">
            <p className="text-center text-[12px] font-data tracking-[0.16em] text-foreground-400">
              INGEST → FILTER → DECIDE → EXECUTE → MANAGE → RECORD → BACK TO MARKET
            </p>
            <p className="flex items-center gap-2 text-center text-[11px] font-data tracking-[0.16em] text-primary-700">
              <i className="ri-loop-left-line text-[13px]"></i>
              ON REJECT · FILTER LOOPS BACK TO INGEST
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default SystemLoop;